import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import queryClient from './queryClient';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <HashRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#1e293b',
              color: '#f1f5f9',
              borderRadius: '0.75rem',
              padding: '1rem'
            },
            success: {
              iconTheme: {
                primary: '#22c55e',
                secondary: '#f1f5f9'
              }
            },
            error: {
              iconTheme: {
                primary: '#ef4444',
                secondary: '#f1f5f9'
              }
            }
          }}
        />
      </HashRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
